import Switch from './Switch';

const Objects = () => {
  return <Switch />;
};

export default Objects;
